import {Popover} from 'react-tiny-popover'
import {useState} from "react";
import './popover.css'

export default function PopoverComponent({placement, content, children, width}) {
    const [isHovering, setIsHovering] = useState(false)
    const [isClicked, setIsClicked] = useState(false)
    return (
        <Popover
            isOpen={isHovering || isClicked}
            positions={placement}
            padding={16}
            align='center'
            containerClassName={width ? width : PopoverWidth.default}
            reposition={true}
            content={content}
            onClickOutside={() => setIsClicked(false)}
        >
            <g
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                onClick={() => setIsClicked(!isClicked)}
            >
                {children}
            </g>
        </Popover>
    );
}

export const PopoverPlacement = {
    leftTop: ['left', 'top', 'bottom', 'right'],
    leftBottom: ['left', 'bottom', 'top', 'right'],
    topLeft: ['top', 'left', 'right', 'bottom'],
    topRight: ['top', 'right', 'left', 'bottom'],
    rightTop: ['right', 'top', 'bottom', 'left'],
    rightBottom: ['right', 'bottom', 'top', 'left'],
    bottomLeft: ['bottom', 'left', 'right', 'top'],
    bottomTop: ['bottom', 'top', 'left', 'right'],
    bottomRight: ['bottom', 'right', 'left', 'top'],
}

export const PopoverWidth = {
    default: "",
    wide: " wide"
}
